import styled from 'styled-components';

import { Button } from '@mui/material';

export const ButtonStyled = styled(Button)`
    text-transform: none;
    font-weight: 600;
    font-size: 1rem;
`;
